<template>
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
  >
    <path d="M1.24664 7V1H9.27505L7.33978 3.70938C7.2156 3.88323 7.2156 4.11677 7.33978 4.29062L9.27505 7H1.24664ZM1.24664 8H10.2466C10.6533 8 10.8899 7.54032 10.6535 7.20938L8.36109 4L10.6535 0.790619C10.8899 0.459685 10.6533 0 10.2466 0H0.746643C0.470501 0 0.246643 0.223858 0.246643 0.5V11.5C0.246643 11.7761 0.470501 12 0.746643 12C1.02279 12 1.24664 11.7761 1.24664 11.5V8Z" />
  </svg>
</template>
